export default class Markup {
  static format(text) {
    text = text.replace(/#\s?([^\n]+\n?)/gm, '<h1>$1</h1>')
    text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    text = text.replace(/(\[([^\]]+)\]\()?(https?:\/\/([^\s/]+)([^\s\)]*))\)?/gi, (correspondance, p1, p2, p3, p4, p5) => `<a href="${p3}" target="_blank">${p2 ?? p4}</a>`)
    text = text.replace(/\*\s?([^\n]+\n?)/gm, '<ul><li>$1</li></ul>')
    text = text.replace(/<\/ul><ul>/gm, '')
    text = text.replace(/\*([^*]+)\*/g, '<em>$1</em>')
    text = text.replace(/\n/g, '<br />')
    text = text.replace(/<br \/><\/li>/g, '</li>')
    text = text.replace(/<br \/><\/h1>/g, '</h1>')
    return text
  }
}
